import { Card, PageHeader } from "../../components/shared/UIComponents";
import { SuperAdminAPI } from "../../services/api";
import { useAsyncData } from "../../hooks/useAsyncData";

export default function SASocieties() {
  const { data: societies, loading, error } = useAsyncData(() => SuperAdminAPI.getAllSocieties());

  return (
    <Card>
      <PageHeader title="All Societies" sub="Societies managed by registered admins" />
      <div style={{ padding:"0 20px 20px" }}>
        {loading && <div style={{ padding:30, textAlign:"center", color:"#78909c" }}>Loading…</div>}
        {error   && <div style={{ padding:16, color:"#c62828" }}>Error: {error}</div>}
        {!loading && (
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead>
                <tr style={{ background:"#f5f7fa" }}>
                  {["#","Society Name","Registration No","City","State","Status","Admin"].map(h=>(
                    <th key={h} style={{ padding:"10px 12px", textAlign:"left", fontWeight:600, color:"#546e7a", fontSize:11, textTransform:"uppercase", borderBottom:"2px solid #e8eaf0" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {societies.length === 0 && <tr><td colSpan={7} style={{ padding:30, textAlign:"center", color:"#90a4ae" }}>No societies found.</td></tr>}
                {societies.map((s, i) => (
                  <tr key={s.id||i} style={{ borderBottom:"1px solid #f0f2f5" }}
                    onMouseEnter={e=>e.currentTarget.style.background="#fafbfc"}
                    onMouseLeave={e=>e.currentTarget.style.background=""}>
                    <td style={{ padding:"10px 12px", color:"#90a4ae" }}>{i+1}</td>
                    <td style={{ padding:"10px 12px", fontWeight:600, color:"#263238" }}>{s.societyName||s.name}</td>
                    <td style={{ padding:"10px 12px", color:"#546e7a", fontFamily:"monospace" }}>{s.registrationNumber||"—"}</td>
                    <td style={{ padding:"10px 12px" }}>{s.city||"—"}</td>
                    <td style={{ padding:"10px 12px" }}>{s.state||"—"}</td>
                    <td style={{ padding:"10px 12px" }}>
                      <span style={{ padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:700, background:"#e6f4ea", color:"#0f9d58" }}>Active</span>
                    </td>
                    <td style={{ padding:"10px 12px", color:"#546e7a" }}>{s.adminName||s.admin?.name||"—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Card>
  );
}
